import "../../modal.scss";
import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { Datatable } from "../ivaTable/Datatable";
import { IvaState } from "../../../context/iva/IvaState";

Modal.setAppElement("#root"); // Necesario para accesibilidad

const IvaModal = ({ handleChange, handleDescChange, descSelected }) => {
  const name ="Tipo de Iva";
  const [searchIdItem, setSearchIdItem] = useState(null); // ID seleccionado
  const [searchDescItem, setSearchDescItem] = useState(""); // Descripción seleccionada
  const searchInputRef = useRef(null); // Referencia para el campo de entrada
  const [isModalOpen, setIsModalOpen] = useState(false); // Control del modal

  // Sincronizar descSelected inicial con el estado
  useEffect(() => {
    if (descSelected && searchDescItem !== descSelected) {
      setSearchIdItem(0);
      setSearchDescItem(descSelected);
    } else if (!descSelected && searchDescItem !== "") {
      setSearchDescItem("");
    }
  }, [descSelected]);

  const handleRowClick = (selectedId, selectedDesc) => {
    setSearchIdItem(selectedId);
    setSearchDescItem(selectedDesc);
    handleChange(selectedId);
    handleDescChange(selectedDesc);
    setIsModalOpen(false);
  };

  const handleClear = () => {
    setSearchIdItem(null);
    setSearchDescItem("");
    handleChange(null);
    handleDescChange("");
    if (searchInputRef.current) {
      searchInputRef.current.value = `Buscar ${name}`;
    }
  };

  return (
    <>
      <div className="inputWrapper">
        <input
          type="text"
          value={searchDescItem || "Buscar " + name}
          readOnly
          ref={searchInputRef}
        />
        {!searchIdItem && !searchDescItem && (
          <button
            className="SearchButton"
            onClick={(e) => {
              e.preventDefault();
              setIsModalOpen(true);
            }}
          >
            🔍
          </button>
        )}
        {(searchIdItem || searchDescItem) && (
          <button
            className="clearButton"
            onClick={(e) => {
              e.preventDefault();
              handleClear();
            }}
          >
            ❌
          </button>
        )}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Seleccionar"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="data-grid-container">
          <div
            className="datatable"
            style={{
              height: "100%",
              maxHeight: "calc(80vh - 60px)",
              overflowY: "auto",
            }}
          >
            <IvaState>
              <Datatable
                onSelect={handleRowClick}
                onClose={() => setIsModalOpen(false)}
              />
            </IvaState>
          </div>
        </div>
        <button
          className="modalCloseButton"
          onClick={() => setIsModalOpen(false)}
        >
          ❌
        </button>
      </Modal>
    </>
  );
};

export default IvaModal;
